import React, { Suspense, useEffect, useState } from "react";
import LoadingIndicator from "../components/LoadingIndicator";
import ContentBox from "../components/contents/ContentBox";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PageWrapper from "../components/PageWrapper";
import SortByTag from "../components/SortByTag";
import Search from "../components/Search";

import configs from "../configs.json";
import { BaseURL, getData, postData } from "../FatchApi/FatchApi";
import { useNavigate } from "react-router-dom";

const OrderedProductPreview = React.lazy(() =>
  import("../components/products/OrderedProductPreview")
);

const DashboardPage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [saleData, setSaleData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getAllOrders = async () => {
    let url1 = "api/chart/order-data";
    let url2 = "api/chart/order-sales";
    
    if (startDate && endDate) {
      url1 += `?startDate=${startDate}&endDate=${endDate}`;
      url2 += `?startDate=${startDate}&endDate=${endDate}`;
    }

    const res = await getData(url1);
    const res2 = await getData(url2);
    setData(res?.formattedOrders || []);
    setSaleData(res2?.formattedData || []);
  };

  useEffect(() => {
    getAllOrders();
  }, [startDate, endDate]);
  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Monthly Orders",
    },
    xAxis: {
      categories: data?.map((order) => order.month),
    },
    yAxis: {
      title: {
        text: "Number of Orders",
      },
    },
    series: [
      {
        name: "Orders",
        data: data?.map((order) => order.count),
      },
    ],
  };
  const options2 = {
    chart: {
      type: "line",
    },
    title: {
      text: "Monthly Sales Report",
    },
    xAxis: {
      categories: saleData?.map((order) => order.month),
    },
    yAxis: {
      title: {
        text: "Amount",
      },
    },
    series: [
      {
        name: "Sales",
        data: saleData?.map((order) => order.totalAmount),
      },
    ],
  };
  console.log(saleData);
  return (
    <PageWrapper>
      <div className="w-full">
        <div className="flex justify-between relative">
          <div>
            <h1 className="text-lg text-gray-100 font-bold leading-5">
              Hello {configs.userName}!
            </h1>
            <p className="text-gray-300 leading-5">
              Welcome back {configs.userName.split(" ")[0]}, and great to meet
              you
            </p>
          </div>
          <div className="flex items-center space-x-2 bg-glitch-box p-2 rounded-lg">
            <div className="flex flex-col">
              <label className="text-xs text-gray-400">Start Date</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="bg-transparent text-white text-sm outline-none border-b border-gray-600 focus:border-glitch-orange transition-colors"
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs text-gray-400">End Date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="bg-transparent text-white text-sm outline-none border-b border-gray-600 focus:border-glitch-orange transition-colors"
              />
            </div>
            { (startDate || endDate) && (
              <button 
                onClick={() => { setStartDate(""); setEndDate(""); }}
                className="text-xs text-rose-500 hover:text-rose-400 mt-4 px-2"
              >
                Clear
              </button>
            )}
          </div>
        </div>

        {/* Store status */}
        {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4 overflow-x-auto mt-10">
          <DisplaySection
            displayText="$5333"
            subText="Total Sales"
            icon={TotalSalesIcon}
          />

          <DisplaySection
            icon={ShoppingCartIcon}
            displayText={"133"}
            subText={"Product Orders"}
          />

          <DisplaySection
            icon={StoreIcon}
            displayText={"3344"}
            subText={"Store Views"}
          />

          <DisplaySection
            icon={LeadershipIcon}
            displayText={"234"}
            subText={"Product Views"}
          />
        </div> */}

        {/* Active orders */}
        <ContentBox name="Charts" className="bg-white">
          <>
            <div className="border-b border-b-glitch-box">
              <SortByTag tags={[]} />
            </div>

            <div className="mt-5"></div>
            <Suspense fallback={<LoadingIndicator />}>
              <div className="bg-white grid grid-cols-2">
                <div className=" my-10">
                  <HighchartsReact highcharts={Highcharts} options={options} />
                </div>
                <div className=" my-10">
                  <HighchartsReact highcharts={Highcharts} options={options2} />
                </div>
              </div>
            </Suspense>
          </>
        </ContentBox>
      </div>
    </PageWrapper>
  );
};

export default DashboardPage;
